import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'

interface ButtonProps {
  children: ReactNode
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'luxury'
  size?: 'sm' | 'md' | 'lg'
  icon?: LucideIcon
  iconPosition?: 'left' | 'right'
  fullWidth?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: (() => void) | (() => Promise<void>)
  className?: string
  type?: 'button' | 'submit' | 'reset'
  href?: string
}

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  fullWidth = false,
  loading = false,
  disabled = false,
  onClick,
  className = '',
  type = 'button',
  href,
}: ButtonProps) => {
  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline',
    ghost: 'btn-ghost',
    luxury: 'btn-luxury',
  }

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg',
  }

  const iconOnly = !!Icon && !children
  
  // اگر href داشته باشیم، یک لینک بسازیم
  if (href) {
    return (
      <a
        href={href}
        className={`
          ${variantClasses[variant]}
          ${sizeClasses[size]}
          ${fullWidth ? 'w-full' : ''}
          ${iconOnly ? 'aspect-square p-0' : ''}
          ${className}
          btn
          inline-flex items-center justify-center no-underline
        `}
      >
        <div className="flex items-center justify-center gap-2">
          {Icon && iconPosition === 'left' && <Icon className="h-4 w-4" />}
          {children && <span>{children}</span>}
          {Icon && iconPosition === 'right' && <Icon className="h-4 w-4" />}
        </div>
      </a>
    )
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${iconOnly ? 'aspect-square p-0' : ''}
        ${className}
        btn
      `}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
          {children && <span>در حال پردازش...</span>}
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          {Icon && iconPosition === 'left' && <Icon className="h-4 w-4" />}
          {children && <span>{children}</span>}
          {Icon && iconPosition === 'right' && <Icon className="h-4 w-4" />}
        </div>
      )}
    </button>
  )
}

export default Button